module.exports = __webpack_public_path__ + "img/nivel_h.ae19b069.png";